import React, { useState, useEffect } from "react";
import { ModeJsonModel } from "../../models/BlockTransportSystemJsonModel";
import { Button, Col, Container, Form, FormGroup, Row, Stack } from "react-bootstrap";

interface IProps {
  selectedMode?: ModeJsonModel;
  onClickAddMode: (mode: ModeJsonModel) => void;
  onClickCopyMode: (mode: ModeJsonModel) => void;
  onClickRemoveMode: (mode: ModeJsonModel) => void;
  onClickSave: (mode: ModeJsonModel) => void;
  onClickPublish: () => void;
}

const ModeInfoCard = ({
  selectedMode,
  onClickAddMode,
  onClickCopyMode,
  onClickRemoveMode,
  onClickSave,
  onClickPublish
}:IProps) => {
  const [mode, setMode] = useState<ModeJsonModel>({...selectedMode});

  useEffect(() => {
    setMode({...selectedMode});
  }, [selectedMode]);

  return (
    <Container fluid className="border rounded mb-2 p-2">
      <FormGroup as={Row} className="mb-1">
        <Form.Label column sm="2">아이디</Form.Label>
        <Col>
          <Form.Control
            size="sm"
            type="text" plaintext readOnly
            value={mode?.id ?? ""}/>
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-1">
        <Form.Label column sm="2">이름</Form.Label>
        <Col>
          <Form.Control
            size="sm"
            type="text"
            value={mode?.name ?? ""}
            onChange={(e) => setMode({...mode, name: e.target.value})}/>
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-1">
        <Form.Label column sm="2">설명</Form.Label>
        <Col>
          <Form.Control
            size="sm"
            type="text"
            value={mode?.description ?? ""}
            onChange={(e) => setMode({...mode, description: e.target.value})}
          />
        </Col>
      </FormGroup>
      <Stack direction="horizontal" gap={3}>
        <Button onClick={() => onClickAddMode(mode)}>추가</Button>
        <Button disabled={!selectedMode} onClick={() => onClickCopyMode(mode)}>복제</Button>
        <Button disabled={!selectedMode} onClick={() => onClickSave(mode)}>저장</Button>
        <Button disabled={!selectedMode} onClick={() => onClickPublish()}>게시</Button>
        <Button variant="danger" disabled={!selectedMode} onClick={() => onClickRemoveMode(mode)}>제거</Button>
      </Stack>
    </Container>
  )
}

export default ModeInfoCard;